import React, { useEffect, useState } from "react"
import { Card, Col, Container, Row } from "react-bootstrap"

import CRUDField from "../core/genericCRUD/CRUDField"
import FieldSelector from "../core/FieldSelector"
import { useTranslation } from "react-i18next"
import { useFormik } from "formik"
import * as yup from "yup"
import yupTypeValidator from "../../common/YupTypeValidator"
import API from "../../common/API"
import { parsedUser } from "../../common/GetCurrentUser"

import { Base64ToFile } from "../../common/helpers"

import CRUD from "../core/genericCRUD/CRUD"
import VehicleFieldsDTO from "./VehicleFieldsDTO"
import { confirmAlert } from "react-confirm-alert"
import { useParams } from "react-router"

import LaborEmployeAddEdit from "./LaborEmployeAddEdit"

const LaborAccessRequestProviderExternal = props => {
  // PROPERTIES
  const vehicleFields: CRUDField[] = VehicleFieldsDTO
  const [record, setRecord] = useState<any>(null)
  const user = parsedUser()
  const [completeRequest, setCompleteRequest] = useState<boolean>(false)
  const fields: CRUDField[] = [
    {
      title: "Representante Laboral",
      htmlType: "separator",
      dbType: "string",
      name: "",
    },
    {
      name: "rnc",
      title: "RNC",
      htmlType: "searchRNC",
      dbType: "string",
      required: false,
      readOnly: true,
      containerClass: " col-12 col-md-4",
      groupNumber: 0,
    },
    {
      name: "companyName",
      htmlType: "text",
      dbType: "string",
      readOnly: true,
      title: "Company Name",
      containerClass: "col-12 col-md-4",
      required: true,
    },
    {
      name: "typeOfRepresentativeId",
      title: "Tipo de representante",
      htmlType: "select",
      dbType: "string",
      readOnly: true,
      required: false,
      containerClass: "col-md-4 col-12",
      groupNumber: 0,

      dataSourceTextField: "name",
      dataSourceValueField: "id",
      dataSourceLocal: [
        {
          id: "1",
          name: "Contratista",
        },
        {
          id: "3",
          name: "Intermediario",
        },
        {
          id: "2",
          name: "Subcontratista",
        },
        {
          id: "4",
          name: "Suplidor",
        },
        {
          id: "5",
          name: "Proveedor de Servicios",
        },
      ],
    },

    {
      name: "responsableId",
      title: "Cédula de Representante",
      htmlType: "cedula",
      dbType: "string",
      readOnly: true,
      required: false,
      containerClass: "col-md-6  col-12",
    },
    {
      name: "responsableName",
      title: "Nombre de Representante",
      htmlType: "text",
      dbType: "string",
      required: true,
      readOnly: true,
      containerClass: "col-md-6  col-12",
      groupNumber: 0,
      datasourceMethod: "POST",
      dataSource: "employee/list",
      dependOf: "organizationId",
      dependOfValue: user?.OrganizationId,

      dataSourceTextField: "fullName",
      dataSourceValueField: "employeeId",
    },
    {
      name: "responsableEmail",
      title: "Correo Representante",
      htmlType: "text",
      dbType: "string",
      readOnly: true,
      required: false,
      containerClass: " col-12 col-md-6 ",
      groupNumber: 0,
    },
    {
      name: "responsablePhone",
      title: "Télefono Representante",
      htmlType: "text",
      dbType: "string",
      readOnly: true,
      required: false,
      containerClass: " col-12 col-md-6 ",
      groupNumber: 0,
    },
    {
      name: "secondResponsableId",
      title: "Cédula de 2do. Representante",
      htmlType: "cedula",
      dbType: "string",
      readOnly: true,
      required: false,
      containerClass: "col-md-6 col-12",
    },
    {
      name: "secondResponsableName",
      title: "Nombre 2do. Representante",
      htmlType: "text",
      dbType: "string",
      readOnly: true,
      required: false,
      containerClass: "col-md-6 col-12",
    },
    {
      name: "secondResponsablePhone",
      title: "Télefono 2do. Representante",
      htmlType: "text",
      dbType: "string",
      readOnly: true,
      required: false,
      containerClass: " col-12 col-md-6",
      groupNumber: 0,
    },
    {
      name: "secondResponsableEmail",
      title: "Correo 2do. Representante",
      htmlType: "text",
      dbType: "string",
      readOnly: true,
      required: false,
      containerClass: " col-12 col-md-6 ",
      groupNumber: 0,
    },
  ]

  const { t } = useTranslation("global")
  const [formikInitialObject, setFormikInitialObject] = useState<any>({})
  const [validationsSchema, setValidationSchema] =
    useState<yup.ObjectSchema<any>>()
  const [isLoading, setIsLoading] = useState(false)

  const formik = useFormik({
    initialValues: formikInitialObject,
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: validationsSchema,
    onSubmit: () => handleSubmit(),
  })
  type YupSchema =
    | yup.StringSchema
    | yup.BooleanSchema
    | yup.NumberSchema
    | yup.DateSchema
  let { id } = useParams<{ id: string }>()
  // METHODS
  const bindDataRequest = async () => {
    try {
      setIsLoading(true)
      const response = await API.getAction(
        "laborAccessRequest/details?id=" + id
      )
      if (response.data.status === "ok") {
        fillFormikObject(response.data.response)
        setRecord(response.data.response)
      }
    } finally {
      setIsLoading(false)
      bindEmployee()
    }
  }
  const fillFormikObject = (record: any) => {
    fields.forEach((item: CRUDField) => {
      if (item && item.name.length > 0) {
        //console.log("field name", item.name, "RecordValue ", record[item.name]);
        if (record && record[item.name]) {
          formik.setFieldValue(item.name, record[item.name])
        }
      }
    })
  }

  const prepareFormikObject = () => {
    const initialObject: { [key: string]: string } = {}
    const initialObjectValidation: { [key: string]: YupSchema } = {}

    if (fields) {
      fields.forEach((item: CRUDField) => {
        // if (item.FieldName === "Id" || item.FieldName === "File") return;

        initialObject[item.name] = item.value

        if (item.required) {
          const schema = yupTypeValidator(item)
          if (schema) {
            initialObjectValidation[item.name] = schema
          }
        }
      })
    }

    // formik.initialValues = initialObject;
    setFormikInitialObject(initialObject)
    setValidationSchema(yup.object().shape(initialObjectValidation))
  }
  const resultadosRnc = async (value: any) => {
    // formik.setFieldValue("cedula", value)
    let item = value[0]
    if (item) {
      formik.setFieldValue("companyName", item.nombre)
    }
    console.log("relatives", value)
  }
  const updateField = (fieldName: string, fieldValue: any) => {
    //console.log(fieldName, fieldValue)
    formik.setFieldValue(fieldName, fieldValue)
  }

  const resultadosCedula = async (value: any, field?: string) => {
    console.log("cedula", value, field)
    let item = value[0]
    if (item) {
      if (field && field === "responsableId") {
        formik.setFieldValue(
          "responsableName",
          item.nombres + " " + item.apellido1 + " " + item.apellido2
        )
      }
      if (field && field === "secondResponsableId") {
        formik.setFieldValue(
          "secondResponsableName",
          item.nombres + " " + item.apellido1 + " " + item.apellido2
        )
      }

      if (item.imagen) {
        let file = Base64ToFile(
          "data:image/jpeg;base64," + item.imagen,
          item.cedula + ".jpg"
        )
        let bodyData = new FormData()
        bodyData.append("path", file)
        const request = await API.postAction(`File/Upload`, bodyData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        if (field === "secondResponsableId") {
          formik.setFieldValue("secondResponsablePhoto", request.data.response)
        }
        if (field === "responsableId") {
          formik.setFieldValue("responsablePhoto", request.data.response)
        }
      }
    }
    console.log("relatives", value)
  }
  const selectMapSearch = async (value: any) => {
    formik.setFieldValue("latitude", value.geometry.location.lat)
    formik.setFieldValue("longitude", value.geometry.location.lng)
    formik.setFieldValue("locationMap", {
      lat: value.geometry.location.lat,
      lng: value.geometry.location.lng,
    })
  }

  const handleSubmit = async (shouldContinue?: boolean | undefined) => {
    try {
      console.log("values to submit", formik.values)

      let query = {}
      fields.forEach((item: CRUDField) => {
        if (item && item.htmlType !== "separator" && item.name.length > 0) {
          query[item.name] = formik.values[item.name] ?? null
        }
      })

      query["locationMap"] = undefined
      query["organizationId"] = user.OrganizationId
      console.log(query)
      setIsLoading(true)
      let request = (await API.postAction(
        `laborAccessRequest/AddEdit`,
        query
      )) as any
      if (request.data.status === "ok") {
        setCompleteRequest(true)
      }
    } catch (ex) {
      console.error(ex)
    } finally {
      setIsLoading(false)
    }
  }

  const [showAddEditEmployee, setShowAddEditEmployee] = useState<boolean>(false)
  const toggleAddEditEmployee = () => {
    setShowAddEditEmployee(!showAddEditEmployee)
    if (showAddEditEmployee) {
      bindEmployee()
    }
  }
  const [employees, setEmployees] = useState<any[]>([])
  const bindEmployee = async () => {
    try {
      const request = await API.getAction(
        "laborAccessRequestProvider/getEmployees?laborAccessRequestId=" + id
      )
      if (request.data.status === "ok") {
        setEmployees(request.data.response)
      }
    } catch (ex) {
      console.error(ex)
    }
  }
  const removeEmployee = async (item: any) => {
    if (item) {
      confirmAlert({
        closeOnClickOutside: false,
        message: t("Are you sure you want to delete this record?") ?? "",
        buttons: [
          {
            label: t("Yes"),
            onClick: async () => {
              await API.getAction(
                "laborAccessRequestProvider/RemoveEmployee?id=" + item.id
              )
              setEmployees(
                employees.filter((record: any) => record.id !== item.id)
              )
            },
          },
          {
            label: "No",
            onClick: () => {
              console.log("no")
            },
          },
        ],
      })
    }
  }

  // EVENTS
  useEffect(() => {
    prepareFormikObject()
  }, [])

  useEffect(() => {
    setRecord(props.record)
  }, [props.record])

  useEffect(() => {
    if (id) {
      bindDataRequest()
    }
  }, [id])

  if (completeRequest) {
    return (
      <Container>
        <div className="flex gap-2 flex-col px-4  my-4 py-4 text-center">
          <div className="alert alert-success">
            <strong>Solicitud exitosa!</strong>
            <br />
            Solicitud recibida, nos contactaremos a la brevedad.
          </div>
        </div>
      </Container>
    )
  }
  return (
    <Container>
      {showAddEditEmployee && (
        <LaborEmployeAddEdit
          toggle={toggleAddEditEmployee}
          title={t("Employee")}
          cssClass="modalRight"
          laborAccessRequestId={id}
        />
      )}

      <div className="flex gap-2 flex-col p-4">
        <Card className="my-4">
          <Card.Header>
            <Card.Title className="text-uppercase">
              {t("Solicitud de acceso laboral - REPRESENTANTE LABORAL")}
            </Card.Title>
          </Card.Header>
          <Card.Body>
            <Row>
              {fields &&
                fields
                  .filter(x => x.htmlType !== "hidden")
                  .map((item, index) => {
                    return (
                      <FieldSelector
                        key={index}
                        model={{
                          ...item,
                        }}
                        resultadosRnc={resultadosRnc}
                        updateField={updateField}
                        selectMapSearch={selectMapSearch}
                        resultadosCedula={resultadosCedula}
                        obj={formik.values}
                        value={
                          formik.values[item.name as keyof typeof formik.values]
                        }
                        errors={formik.errors}
                      />
                    )
                  })}

              {/* Sub sections  */}

              <Col xs={12} className="my-4">
                <h4>
                  {t("Lista de empleados") ?? ""}
                  <button
                    className="btn btn-sm ms-2 btn-primary"
                    onClick={() => {
                      toggleAddEditEmployee()
                    }}
                  >
                    <i className="fas fa-plus"></i>
                  </button>
                </h4>
                <hr />
                <div className="table-responsive">
                  <table className="table table-striped table-bordered">
                    <thead>
                      <tr>
                        <th>{t("Name")}</th>
                        <th>{t("Last Name")}</th>
                        <th>{t("Employment Type")}</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {employees &&
                        employees.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>{item.firstName}</td>
                              <td>{item.lastName}</td>
                              <td>{item.employeeType}</td>
                              <td className="text-end">
                                <button
                                  className="btn btn-primary btn-sm"
                                  onClick={() => {
                                    removeEmployee(item)
                                  }}
                                >
                                  <i className="fas fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          )
                        })}
                    </tbody>
                  </table>
                </div>
              </Col>

              <Col xs={12} className="my-4 px-0 mx-0">
                <CRUD
                  fields={vehicleFields}
                  isModal={false}
                  id="vehicleForm"
                  headerStyle={"justButtons"}
                  // modalSize="sm"
                  cssClass="modalRight"
                  filterOpen={false}
                  readOnly={props.readOnly}
                  // showModal={props.show}
                  // toggleCRUD={props.toggle}
                  title={t("Vehiculo de transporte laboral ") ?? ""}
                  // icon={"fas fa-building"}
                  parentId="laborAccessRequestId"
                  parentValue={id}
                  getRecordsMethod="post"
                  getRecordsPath={`laborAccessRequestVehicle/list`}
                  addEditRecordPath={`laborAccessRequestVehicle/AddEdit`}
                  deleteRecordPath="laborAccessRequestVehicle/Delete"
                  fieldsList={[
                    {
                      name: "driverName",
                      title: t("Conductor"),
                      htmlType: "text",
                    },
                    {
                      name: "driverLicense",
                      title: t("Licencia"),
                      htmlType: "text",
                    },
                    {
                      name: "vehiclePlate",
                      title: t("Placa"),
                      htmlType: "text",
                    },
                    {
                      name: "insurancePolicyNumber",
                      title: t("No. de poliza de seguro"),
                      htmlType: "text",
                    },
                  ]}
                />
              </Col>
            </Row>
          </Card.Body>
          <Card.Footer className="text-end">
            {isLoading && (
              <div className="me-4 d-inline-block">
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            )}

            <button
              className="btn btn-primary text-white"
              disabled={isLoading}
              onClick={() => setCompleteRequest(true)}
              type="button"
            >
              {t("Finalizar")}
            </button>
          </Card.Footer>
        </Card>
      </div>
    </Container>
  )
}

export default LaborAccessRequestProviderExternal
